import React from 'react';
import img from '../images/strengths/multi_dis.png'; 
import img2 from '../images/strengths/cost_effective.png';
import img4 from '../images/strengths/smooth_execution.png';
import img5 from '../images/strengths/cutting_edge.png';
import img3 from '../images/strengths/partnership.png';

const Strengths = () => {
  const strengths = [
    { 
      img, 
      title: "Multi-Skilled Team", 
      desc: `A strong team that excels in Mechanical + Electronics + Software + AI engineering, across diverse industries`
    },
    { img: img2, title: "Dedicated Partnership", desc: "Understanding partner requirements, and valuing cost-effective long-term growth of partners" },
    { img: img3, title: "Utmost Integrity", desc: "Highest care in information handling, and professional conduct" },
    { img: img4, title: "Smooth Execution", desc: "Timely delivery with minimal operational disruption" },
    { img: img5, title: "Cutting-Edge R&D", desc: "Staying ahead with latest advanced technologies, giving our partners a competitive edge." },
  ];

  return (
    <div id="strengths" className="py-24 bg-gradient-to-br from-blue-50 to-white overflow-hidden">
      {/* Header */}
      <div className="text-center mb-16">
        <h2 className="my-2 text-center text-3xl uppercase font-bold" style={{ color: '#005690' }}>Our Strengths</h2>
        <div className="flex justify-center mb-6">
          <div className="w-28 h-1 bg-slate-400 rounded-full"></div>
        </div>
        <h2 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold" style={{ color: '#005690' }}>
          The driving force behind our solutions
        </h2>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8 px-6 md:px-12 auto-rows-fr">
        {strengths.map((item, index) => (
          <div 
            key={index} 
            className="relative group transform transition-all duration-500 hover:-translate-y-4 hover:scale-105 cursor-pointer"
          >
            {/* Tile */}
            <div className="bg-gradient-to-br from-blue-900 to-slate-400 rounded-2xl p-6 flex flex-col items-center text-center shadow-2xl min-h-[180px]">
              <img src={item.img} alt={item.title} className="w-20 h-20 mb-4 rounded-full object-cover border-2 border-slate-300" />
              <h3 className="text-xl font-bold text-gray-100">{item.title}</h3>
            </div>

            {/* Hover Overlay */}
            <div className="absolute inset-0 bg-slate-100 bg-opacity-90 rounded-2xl p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-center items-center text-center shadow-xl min-h-[220px]">
              <h3 className="text-lg font-bold text-blue-900 mb-2">{item.title}</h3>
              <p className="text-gray-700 text-sm">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Strengths;
